import { Bounce, toast } from "react-toastify";

export const notify = (successMsg) => {
  console.log(successMsg)
    toast.success(`${successMsg}`, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
      className: "bg-success", 
      
    });
  };
  
  export const notify1 = (errMsg) => {
    toast.error(`${errMsg}`, {
      position: "top-right",
      autoClose:1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });
  };